import configuration from "./../config.json";
import reportService from "../shared/services/reportService";
import CookieService from "./../shared/services/cookiesService";
import { setLogout } from "./authActions";

const REQUEST_DELETE_REPORT = "REQUEST_DELETE_REPORT";
const RESPONSE_DELETE_REPORT = "RESPONSE_DELETE_REPORT";
const REQUEST_DELETE_REPORT_FAILURE = "REQUEST_DELETE_REPORT_FAILURE";

const requestDeleteReportAction = (id) => {
  return {
    type: REQUEST_DELETE_REPORT,
    id,
  };
};

const responseDeleteReportAction = (data) => {
  return {
    type: RESPONSE_DELETE_REPORT,
    data,
  };
};

const requestDeleteReportFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_REPORT_FAILURE,
    errors,
  };
};

const deleteReport = (id) => {
  return (dispatch) => {
    dispatch(requestDeleteReportAction(id));

    reportService
      .deleteReport(id)
      .then((result) => {
        CookieService.updateExpires(configuration.cookieName, 12);

        dispatch(responseDeleteReportAction(id));
      })
      .catch((error) => {
        dispatch(requestDeleteReportFailureAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

export {
  deleteReport,
  requestDeleteReportAction,
  responseDeleteReportAction,
  requestDeleteReportFailureAction,
  REQUEST_DELETE_REPORT,
  RESPONSE_DELETE_REPORT,
  REQUEST_DELETE_REPORT_FAILURE,
};
